const baseUrl = '/companies';
export const companiesRoutes = {
  baseUrl: "".concat(baseUrl),
  company: id => "".concat(baseUrl, "/").concat(id),
  companyTypes: "".concat(baseUrl, "/company-types"),
  companyUnits: companyId => "".concat(baseUrl, "/").concat(companyId, "/units"),
  billIntakeAlias: id => "".concat(baseUrl, "/").concat(id, "/bill-intake-alias"),
  billIntakeAliasHistory: id => "".concat(baseUrl, "/").concat(id, "/bill-intake-alias/history"),
  billIntakeAliasRotate: id => "".concat(baseUrl, "/").concat(id, "/bill-intake-alias/rotate"),
  subscriptionTier: id => "".concat(baseUrl, "/").concat(id, "/subscription-tier"),
  emailIn: id => "".concat(baseUrl, "/").concat(id, "/email-in"),
  convergentBilling: id => "".concat(baseUrl, "/").concat(id, "/convergent-billing"),
  customerType: id => "".concat(baseUrl, "/").concat(id, "/customer-type"),
  billNotifications: id => "".concat(baseUrl, "/").concat(id, "/bill-notifications"),
  properties: id => "".concat(baseUrl, "/").concat(id, "/properties-v2"),
  propertiesLegacy: id => "".concat(baseUrl, "/").concat(id, "/properties"),
  propertyList: companyId => "".concat(baseUrl, "/").concat(companyId, "/property-list"),
  residentAddendums: id => "".concat(baseUrl, "/").concat(id, "/residentAddendums")
};